/** Reattachment can lose focus even when the original node is connected again. */
export function restoreRenderFocus(
  container: HTMLElement,
  selector: string | null,
  previous: HTMLElement | null,
): void {
  if (
    selector &&
    document.activeElement !== previous &&
    document.activeElement === document.body
  )
    container
      .querySelector<HTMLElement>(selector)
      ?.focus({ preventScroll: true });
}
